import { Grid } from '@mui/material';
import PaymentInformation from 'models/PaymentInformation';
import React, { useEffect, useState } from 'react';
import { useUserContext } from 'UserContext';
import { PayBackgroundPaper } from './PayPapers';
import PaySectionHeader from './PaySectionHeader';
import { Text, OutlinedDropdown } from 'library';
import { client, consoleLogInDev } from 'shared';
import { ISetupData } from '../models';
import SetupIntentInfo from '../setup/SetupIntentInfo';

type SetupResponse = ISetupData | { verified: true } | null;

function isVerifiedResponse(response: SetupResponse): response is { verified: true } {
    return !!response && 'verified' in response && response.verified === true;
}

function isSetupData(response: SetupResponse): response is ISetupData {
    return !!response && 'verification_url' in response && typeof response.verification_url === 'string';
}

export default function MicrodepositsEntry() {
    const [selectedAccount, setSelectedAccount] = useState('');
    const [setupData, setSetupData] = useState<SetupResponse>(null);

    const { user, refreshAlreadyLoggedInUser } = useUserContext();
    const paymentSetup = user?.payment_information;

    const accountsToVerify = paymentSetup?.filter((x: PaymentInformation) => x.status === 'NEW');
    const accountOptions = accountsToVerify?.map((x) => {
        return { key: x.id.toString(), value: x.last_four || '' };
    });

    const options = [{ key: '0', value: 'Select Account' }, ...(accountOptions || [])];

    useEffect(() => {
        if (accountOptions?.length) {
            setSelectedAccount(accountOptions[0].key);
        }
    }, [paymentSetup]);

    useEffect(() => {
        if (selectedAccount && selectedAccount !== '0') {
            client(`payment/api/pay-setup/${selectedAccount}/setup-intent/`)
                .then((response: SetupResponse) => {
                    setSetupData(response);
                    if (isVerifiedResponse(response)) {
                        refreshAlreadyLoggedInUser();
                    }
                })
                .catch(consoleLogInDev);
        }
    }, [selectedAccount]);

    if (!accountsToVerify?.length) return null;

    return (
        <Grid item md={12}>
            <PayBackgroundPaper>
                <PaySectionHeader>Manual Account Verification</PaySectionHeader>
                <Text variant="body1">
                    You&apos;ll receive a single deposit for $0.01 with a descriptor code that starts with
                    &quot;SM&quot;. Follow the link once you receive it to complete your account setup. Refresh page
                    when complete.
                </Text>
                <Grid container direction="row" alignItems="center" style={{ padding: 5 }}>
                    <Text variant="body2" textStyle={{ marginRight: 5 }}>
                        Account Ending In:
                    </Text>
                    <OutlinedDropdown
                        fields={options}
                        value={selectedAccount || ''}
                        onChange={(x) => setSelectedAccount(x.target.value)}
                        displayEmpty
                    />
                </Grid>
                {isSetupData(setupData) && <SetupIntentInfo setupData={setupData} />}
            </PayBackgroundPaper>
        </Grid>
    );
}
